import React from "react";
import ImageShare from "../ImageShare/ImageShare";
import Share from "../Share/Share";
export default function Export() {
  return (
    <>
      <p className="font-semibold text-gray-800 flex items-center text-lg">
        <span className="text-xl font-medium ri-share-forward-fill "></span>
        &nbsp; Export Settings
      </p>
      <div className="image">
        <ImageShare />
        <Share txt="SHARE IMAGE" />
      </div>

    </>
  );
}
